/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

/* eslint-env browser, commonjs, jquery */

// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');
    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');
    document.getElementsByTagName('head')[0].appendChild(s);
}

require('_core_ext/async-css');
require('_core_ext/js-lib')();
require('_core_ext/js-ext')();
require('_core_ext/jquery-ext')();
require('./global')();
require('_core_ext/cookieprivacy')();
require('_core_ext/captcha')();

var app = window.app = {
    init: function () {
        this.components.extendConfig(require('./components-config')).initAll();
    },
    'page' : require('_core_ext/page'),
    'components' : require('_core_ext/components')
};

// initialize app
$(document).ready(function () {
    app.init();
    // ===============================
    // /* Accessibility – initial focus */
    // ===============================
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
            document.body.classList.add('keyboard-mode');

            const skipLink = document.querySelector('.skip-link');

            if (skipLink) {
                e.preventDefault();
                skipLink.focus();
            }
        }
    }, {once: true});

    document.querySelector('.js-countrySelector')
        .addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });

    (function () {
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Tab' || e.keyCode === 9) {
                document.body.classList.add('keyboard-mode');
            }
        });
        document.addEventListener('mousedown', function () {
            document.body.classList.remove('keyboard-mode');
        });

        document.addEventListener('touchstart', function () {
            document.body.classList.remove('keyboard-mode');
        });
    })();
});
